import { capitalize } from '../../../helpers/string'
import { IUnitModel } from '../../../interfaces/models/units.interfaces'

export const getUnitTitle = (unit: IUnitModel): string => {
  const _titleLegal = unit.titleLegal
    ? capitalize(unit.titleLegal.toLowerCase())
    : undefined
  const _title = capitalize(unit.title.toLowerCase())

  if (_titleLegal) {
    return `${_titleLegal} (${_title})`
  }
  return _title
}
